<template>
    <modal
        :title="modal.modalTitle"
        :subtitle="modal.modalSubTitle"
        :open="modal.isModalOpened"
        :showCloseIcon="modal.showCloseIcon"
        :modalClass="modal.modalClass"
        :showModalHeader="modal.showModalHeader"
        :showModalHeaderWhite="modal.showModalHeaderWhite"
        :showModalHeaderWhiteNav="modal.showModalHeaderWhiteNav"
        :hideModalBackdropOnMobile="modal.hideModalBackdropOnMobile"
        @update:close="modal.modalCloseFn">
        <div
          v-if="modalContent && typeof modalContent === 'string'"
          v-dompurify-html="modalContent"
        ></div>
        <div
          v-if="modalContent && typeof modalContent === 'object'"
          :is="modalContent"
          v-bind="modal.modalProps"
          v-on="modal.modalEvents"
        ></div>
    </modal>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import Modal from 'components/Modal/Modal'

  export default {
    components: {
      Modal
    },
    computed: {
      ...mapState('main', [
        'modal'
      ]),
      ...mapGetters('main', [
        'modalContent'
      ])
    }
  }
</script>
